import React from 'react'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { BenefitTrans, TableFeature, useTiersInfo } from '@mc/plans-ui'
import { BOGO_I18N_NAMESPACE, i18nInstance } from '../../../i18n'

const BogoDevicesFeatureComp = () => {
  const { t } = useTranslation(BOGO_I18N_NAMESPACE)
  const { duo, family, individual } = useTiersInfo()

  return (
    <TableFeature.Feature>
      <TableFeature.Label
        title={t('plans.rows.devices.title')}
        subtitle={t('plans.rows.devices.subtitle')}
      />
      <TableFeature.Individual>
        <BenefitTrans
          tier={individual}
          name='concurrent_devices'
          defaultValue={false}
          i18nKey='plans.rows.devices.counter'
          ns={BOGO_I18N_NAMESPACE}
        />
      </TableFeature.Individual>
      <TableFeature.Duo>
        <BenefitTrans
          tier={duo}
          name='concurrent_devices'
          i18nKey='plans.rows.devices.counter'
          ns={BOGO_I18N_NAMESPACE}
        />
      </TableFeature.Duo>
      <TableFeature.Family>
        <BenefitTrans
          tier={family}
          name='concurrent_devices'
          i18nKey='plans.rows.devices.counter'
          ns={BOGO_I18N_NAMESPACE}
        />
      </TableFeature.Family>
    </TableFeature.Feature>
  )
}

export const BogoDevicesFeature = withI18nContext(i18nInstance)(
  BogoDevicesFeatureComp,
)
